unit FsKontrolle;

interface

uses
  System.SysUtils, System.Classes,  System.StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer, WebBasis2, Vcl.Menus, WEBLib.Menus   ;

type
  TfrmFsKontrolle = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    tabFsKontrolle: TXDataWebDataSet;
    tabFsKontrolleID_FSKONTROLLE: TIntegerField;
    tabFsKontrolleDATUM: TStringField;
    tabFsKontrolleFERTIG: TStringField;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    dtDatum: TDateTimePicker;
    cbxFilterDatum: TCheckBox;
    tabFsKontrolleBEMERKUNG: TStringField;
    tabFsKontrolleSTATUS: TStringField;
    btnIns: TTMSFNCToolBarButton;

     //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure ErzeugeItems; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnInsClick(Sender: TObject); async;
    [async] procedure respGridItemDblClick(Sender: TObject; Index: Integer); async;
     //
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);

    procedure lbTauClick(Sender: TObject);
    procedure dtDatumChange(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);


  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmFsKontrolle: TfrmFsKontrolle;

const cForm = 'FSKONTROLLE_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul, FsKontrolleEdit;

//====================================================================================================================//

procedure TfrmFsKontrolle.btnInsClick(Sender: TObject);
var aResult : TModalResult;
    iNewID : Integer;
begin
  inherited;

  Opt_Speichern;

  iNewID := 0;

  await(  DoFsKontrolleEdit( iNewID  ) );

  iID_Akt := iNewID;

  await( Daten_Laden( iNewID ) );

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabFsKontrolle.FieldByName('ID_FSKONTROLLE').AsInteger;
  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  cbxFilterDatum.Checked := SToB( TLocalStorage.GetValue( cForm+'DATUM_FILTER_EIN' ) );

  sDat := TLocalStorage.GetValue( cForm+'DATUM_FILTER' );
  If sDat='' then
       dtDatum.DateTime := Date
  Else dtDatum.DateTime := StrToDateTime(sDat);

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cForm+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cForm+'REC_VON' );
  sBis := TLocalStorage.GetValue( cForm+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.Opt_Speichern;
var sAbf : String;
begin

  sAbf := DateTimeToStr( Trunc( dtDatum.DateTime )   );

  TLocalStorage.SetValue( cForm+'DATUM_FILTER_EIN', BToS( cbxFilterDatum.Checked ));
  TLocalStorage.SetValue( cForm+'DATUM_FILTER', sAbf );

  TLocalStorage.SetValue( cForm+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cForm+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cForm+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sTauStati, sKopfZeile: String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  // Mitarbeiter-Belege ermitteln
  //
  sSQL := '01:SELECT K.ID_FSKONTROLLE, K.DATUM, K.FERTIG, K.FERTIG_AM, K.BEMERKUNG '
         +'   FROM FSKONTROLLE K  WHERE ID_MITARBEITER ='+ frmMainForm.BenutzerMaNr ;

    If cbxFilterDatum.Checked then
      Begin
        dtAbf := Trunc(dtDatum.DateTime);
        sSQL := sSQL +' AND K.DATUM >= '+cH+FormatDateTime('dd.mm.yyyy',dtAbf)+cH
                     +' AND K.DATUM < ' +cH+FormatDateTime('dd.mm.yyyy',dtAbf+1)+cH;
      End;

    sSQL := sSQL + ' ORDER BY K.DATUM DESC ' +';'  ;

    sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  tabFsKontrolle.Close;
  tabFsKontrolle.Open;

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];
          tabFsKontrolle.Append;
            tabFsKontrolle.FieldByName('ID_FSKONTROLLE').AsInteger := SToI(GetFeldWert( sFelder, sDaten, 'ID_FSKONTROLLE' ));
            tabFsKontrolle.FieldByName('DATUM').AsString   := GetFeldWert( sFelder, sDaten, 'DATUM'   );
            tabFsKontrolle.FieldByName('FERTIG').AsString := GetFeldWert( sFelder, sDaten, 'FERTIG' );

            sTmp :=  ReplaceStr( GetFeldWert( sFelder, sDaten, 'BEMERKUNG' ), '##', ' ' );
            tabFsKontrolle.FieldByName('BEMERKUNG').AsString := sTmp;


          tabFsKontrolle.Post;
        End;
    End;

  aSL.Free;
  aSL_Daten.Free;

  If aID = 0 then tabFsKontrolle.First;
  If aID > 0 then
    If not tabFsKontrolle.Locate('ID_FSKONTROLLE',aID,[]) then tabFsKontrolle.First;

  btnNavNext.Enabled := (tabFsKontrolle.RecordCount=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  ErzeugeItems;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.dtDatumChange(Sender: TObject);
var iID : Integer;
begin

  If (Sender=dtDatum) and (cbxFilterDatum.Checked=False) then Exit;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabFsKontrolle.FieldByName('ID_FSKONTROLLE').AsInteger;

  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.WebFormCreate(Sender: TObject);
begin

  Inherited;

  //Console.Log('WebFormCreate----'+IntToStr( frmMainForm.g_RecAnzahl)) ;

  bFirst := False;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;
  btnIns.BitmapContainer := frmMainForm.BitmapCont;

  If Application.IsMobile then
       dtDatum.Width := 95
  Else dtDatum.Width := 130;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.ErzeugeItems;
var aItem : TResponsiveGridItem;
    sText : String;
    aColBG, aColVG : TColor;
begin

  respGrid.Items.Clear;

  tabFsKontrolle.First;
  While not tabFsKontrolle.eof Do
    Begin

      sText := '<p><strong>'+tabFsKontrolleDATUM.AsString+'</strong> - Nr: '+tabFsKontrolleID_FSKONTROLLE.AsString;
      If tabFsKontrolleFERTIG.AsString='1' then sText := sText + '  - FERTIG';
      sText := sText+' </p>';

      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  tabFsKontrolleID_FSKONTROLLE.AsInteger;

      //console.log( inttostr(self.iID_Akt)+' - '+inttostr(tabMaBelegID_MA_BELEG.AsInteger) );

      If tabFsKontrolleID_FSKONTROLLE.AsInteger = self.iID_Akt then
        Begin
          //Console.Log('iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

     tabFsKontrolle.Next;

    end;

end;

//====================================================================================================================//

procedure TfrmFsKontrolle.lbTauClick(Sender: TObject);
begin
// Showmessage( lbMitarbeiter.font.Name );
end;

//====================================================================================================================//

procedure TfrmFsKontrolle.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;
    iID_FsKontrolle : Integer;
begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  iID_FsKontrolle  := aItem.Tag;

  await( DoFsKontrolleEdit( iID_FsKontrolle ) );

  await( Daten_Laden( iID_FsKontrolle ) );


end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmFsKontrolle.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTau -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmMaBeleg');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmMaBeleg: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmFsKontrolle.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  dtDatum := TDateTimePicker.Create(Self);
  cbxFilterDatum := TCheckBox.Create(Self);
  btnIns := TTMSFNCToolBarButton.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabFsKontrolle := TXDataWebDataSet.Create(Self);
  tabFsKontrolleDATUM := TStringField.Create(Self);
  tabFsKontrolleBEMERKUNG := TStringField.Create(Self);
  tabFsKontrolleFERTIG := TStringField.Create(Self);
  tabFsKontrolleSTATUS := TStringField.Create(Self);
  tabFsKontrolleID_FSKONTROLLE := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  dtDatum.BeforeLoadDFMValues;
  cbxFilterDatum.BeforeLoadDFMValues;
  btnIns.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabFsKontrolle.BeforeLoadDFMValues;
  tabFsKontrolleDATUM.BeforeLoadDFMValues;
  tabFsKontrolleBEMERKUNG.BeforeLoadDFMValues;
  tabFsKontrolleFERTIG.BeforeLoadDFMValues;
  tabFsKontrolleSTATUS.BeforeLoadDFMValues;
  tabFsKontrolleID_FSKONTROLLE.BeforeLoadDFMValues;
  try
    Width := 1137;
    Height := 515;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1137;
    WebPanel1.Height := 90;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 16;
    lbTau.Top := 8;
    lbTau.Width := 202;
    lbTau.Height := 18;
    lbTau.Caption := 'F'#252'hrerscheinkontrollen';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 1;
    btnNavPrev.Top := 34;
    btnNavPrev.Width := 60;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 163;
    btnNavNext.Top := 34;
    btnNavNext.Width := 60;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 62;
    btnNavInfo.Top := 34;
    btnNavInfo.Width := 99;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    dtDatum.SetParentComponent(WebPanel1);
    dtDatum.Name := 'dtDatum';
    dtDatum.Left := 277;
    dtDatum.Top := 34;
    dtDatum.Width := 110;
    dtDatum.Height := 44;
    dtDatum.Cursor := crHandPoint;
    dtDatum.BorderStyle := bsSingle;
    dtDatum.ChildOrder := 5;
    dtDatum.Color := 15329769;
    dtDatum.Date := 45767.262767685180000000;
    dtDatum.Role := '';
    dtDatum.ShowSeconds := False;
    dtDatum.Text := '';
    SetEvent(dtDatum, Self, 'OnChange', 'dtDatumChange');
    cbxFilterDatum.SetParentComponent(WebPanel1);
    cbxFilterDatum.Name := 'cbxFilterDatum';
    cbxFilterDatum.Left := 282;
    cbxFilterDatum.Top := 0;
    cbxFilterDatum.Width := 105;
    cbxFilterDatum.Height := 33;
    cbxFilterDatum.Cursor := crHandPoint;
    cbxFilterDatum.Caption := 'Datum';
    cbxFilterDatum.ChildOrder := 6;
    cbxFilterDatum.HeightPercent := 100.000000000000000000;
    cbxFilterDatum.WidthPercent := 100.000000000000000000;
    SetEvent(cbxFilterDatum, Self, 'OnClick', 'dtDatumChange');
    btnIns.SetParentComponent(WebPanel1);
    btnIns.Name := 'btnIns';
    btnIns.Left := 226;
    btnIns.Top := 34;
    btnIns.Width := 50;
    btnIns.Height := 44;
    btnIns.Cursor := crHandPoint;
    btnIns.ParentDoubleBuffered := False;
    btnIns.DoubleBuffered := True;
    btnIns.Font.Charset := DEFAULT_CHARSET;
    btnIns.Font.Color := clWindowText;
    btnIns.Font.Height := -11;
    btnIns.Font.Name := 'Segoe UI';
    btnIns.Font.Style := [];
    btnIns.ParentColor := True;
    btnIns.TabOrder := 5;
    SetEvent(btnIns, Self, 'OnClick', 'btnInsClick');
    btnIns.Text := '';
    btnIns.Bitmaps.Clear;
    with btnIns.Bitmaps.Add do
    begin
      BitmapName := 'INS';
    end;
    btnIns.BitmapVisible := True;
    btnIns.BitmapContainer := BitmapCont;
    btnIns.ControlIndex := 0;
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 90;
    respGrid.Width := 1137;
    respGrid.Height := 425;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 95.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 40;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 5;
    respGrid.Options.ItemWidthMin := 250;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 567;
    BitmapCont.Top := 8;
    tabSprachDaten.Left := 96;
    tabSprachDaten.Top := 104;
    tabFsKontrolle.SetParentComponent(Self);
    tabFsKontrolle.Name := 'tabFsKontrolle';
    tabFsKontrolle.Left := 104;
    tabFsKontrolle.Top := 216;
    tabFsKontrolleDATUM.SetParentComponent(tabFsKontrolle);
    tabFsKontrolleDATUM.Name := 'tabFsKontrolleDATUM';
    tabFsKontrolleDATUM.Alignment := taCenter;
    tabFsKontrolleDATUM.DisplayLabel := 'Datum';
    tabFsKontrolleDATUM.FieldName := 'DATUM';
    tabFsKontrolleDATUM.Size := 10;
    tabFsKontrolleBEMERKUNG.SetParentComponent(tabFsKontrolle);
    tabFsKontrolleBEMERKUNG.Name := 'tabFsKontrolleBEMERKUNG';
    tabFsKontrolleBEMERKUNG.DisplayLabel := 'Bemerkung';
    tabFsKontrolleBEMERKUNG.DisplayWidth := 500;
    tabFsKontrolleBEMERKUNG.FieldName := 'BEMERKUNG';
    tabFsKontrolleBEMERKUNG.Size := 200;
    tabFsKontrolleFERTIG.SetParentComponent(tabFsKontrolle);
    tabFsKontrolleFERTIG.Name := 'tabFsKontrolleFERTIG';
    tabFsKontrolleFERTIG.Alignment := taCenter;
    tabFsKontrolleFERTIG.DisplayLabel := 'Fertig';
    tabFsKontrolleFERTIG.DisplayWidth := 20;
    tabFsKontrolleFERTIG.FieldName := 'FERTIG';
    tabFsKontrolleFERTIG.Size := 1;
    tabFsKontrolleSTATUS.SetParentComponent(tabFsKontrolle);
    tabFsKontrolleSTATUS.Name := 'tabFsKontrolleSTATUS';
    tabFsKontrolleSTATUS.FieldName := 'STATUS';
    tabFsKontrolleSTATUS.Size := 50;
    tabFsKontrolleID_FSKONTROLLE.SetParentComponent(tabFsKontrolle);
    tabFsKontrolleID_FSKONTROLLE.Name := 'tabFsKontrolleID_FSKONTROLLE';
    tabFsKontrolleID_FSKONTROLLE.Alignment := taCenter;
    tabFsKontrolleID_FSKONTROLLE.DisplayWidth := 6;
    tabFsKontrolleID_FSKONTROLLE.FieldName := 'ID_FSKONTROLLE';
    tabFsKontrolleID_FSKONTROLLE.Required := True;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    dtDatum.AfterLoadDFMValues;
    cbxFilterDatum.AfterLoadDFMValues;
    btnIns.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabFsKontrolle.AfterLoadDFMValues;
    tabFsKontrolleDATUM.AfterLoadDFMValues;
    tabFsKontrolleBEMERKUNG.AfterLoadDFMValues;
    tabFsKontrolleFERTIG.AfterLoadDFMValues;
    tabFsKontrolleSTATUS.AfterLoadDFMValues;
    tabFsKontrolleID_FSKONTROLLE.AfterLoadDFMValues;
  end;
end;

end.

